'use client'
import { PrismicNextImage, PrismicNextLink } from '@prismicio/next'
import { useEffect } from 'react'

interface FooterNavProps {
    core?: any | null;
  }
  
  const FooterNav:React.FC<FooterNavProps>  =({ core })=> {

  // console.log(props)

  const footerLinks =[] as any
  let socialLinks = [] as any

  core.data.slices.map((item: any)=>{
    if(item.slice_type === 'footer_links') {
      footerLinks.push(item);
    }
    if(item.slice_type === 'socials') {
      socialLinks = item;
    }
  })


  useEffect(()=>{
      const paramsString = new URL(window.location.href);
      const searchParams = new URLSearchParams(paramsString.search)
      const faq = searchParams.get('f') as any
      const scrollTo = document.getElementById(faq)

      setTimeout(()=>{
        scrollTo?.scrollIntoView()
        scrollTo?.click()
      }, 500);

  },[])

  const footerLinkLabel = (item: any) => {
    try {
      const url = item?.link?.url || '';
      const slug = url.split('?')[0].split('#')[0].split('/').filter(Boolean).pop();
      if (!slug) return item?.link_text || 'Link';
      return slug.replace(/-/g, ' ').replace(/\b\w/g, (c: string) => c.toUpperCase());
    } catch {
      return item?.link_text || 'Link';
    }
  }

  const currentYear = String(new Date().getFullYear())

  return (
    <div className="w-full bg-jade  font-fellix text-white text-[14px] pt-16">
      <div className="px-4 md:px-8 lg:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-12">
            <div className="col-span-12 md:col-span-4 lg:col-span-2">
              <p className="font-semibold text-[20px] leading-7 mb-[13px]">{footerLinks[0].primary.section}</p>
              <ul className="list-none">
              {footerLinks[0].primary.links.map ((item: any, index: number)=>{
                // console.log(item.link.uid)
                return (
                  <li className="hover:underline underline-offset-4" key={index}><PrismicNextLink field={item.link} aria-label={footerLinkLabel(item)} className="inline-flex min-h-11 items-center">{item.link_text}</PrismicNextLink></li>
                )
              })}
              </ul>
              <p className="font-semibold text-[20px] leading-7 mb-[13px] mt-8">{footerLinks[4].primary.section}</p>
              <ul className="list-none">
                {footerLinks[4].primary.links.map ((item: any, index: number)=>{
                  return (
                    <li className="hover:underline underline-offset-4" key={index}><PrismicNextLink field={item.link} aria-label={footerLinkLabel(item)} className="inline-flex min-h-11 items-center">{item.link_text}</PrismicNextLink></li>
                  )
                })}
              </ul>
            </div>
            <div className="col-span-12 md:col-span-4 lg:col-span-2 mt-8 md:mt-0">
              <p className="font-semibold text-[20px] leading-7 mb-[13px]">{footerLinks[1].primary.section}</p>
              <ul className="list-none">
              {footerLinks[1].primary.links.map ((item: any, index: number)=>{
                  return (
                    <li className="hover:underline underline-offset-4" key={index}><PrismicNextLink field={item.link} aria-label={footerLinkLabel(item)} className="inline-flex min-h-11 items-center">{item.link_text}</PrismicNextLink></li>
                  )
              })}
              </ul>
              <p className="font-semibold text-[20px] leading-7 mb-[13px] mt-8">{footerLinks[5].primary.section}</p>
              <ul className="list-none">
                {footerLinks[5].primary.links.map ((item: any, index: number)=>{
                  return (
                    <li className="hover:underline underline-offset-4" key={index}><PrismicNextLink field={item.link} aria-label={footerLinkLabel(item)} className="inline-flex min-h-11 items-center">{item.link_text}</PrismicNextLink></li>
                  )
                })}
              </ul>
            </div>
            <div className="col-span-12 md:col-span-4 lg:col-span-2 mt-8 md:mt-0">
              <p className="font-semibold text-[20px] leading-7 mb-[13px]" >{footerLinks[2].primary.section}</p>
              <ul className="list-none">
              {footerLinks[2].primary.links.map ((item: any, index: number)=>{
                return (
                  <li className="hover:underline underline-offset-4" key={index}><PrismicNextLink field={item.link} aria-label={footerLinkLabel(item)} className="inline-flex min-h-11 items-center">{item.link_text}</PrismicNextLink></li>
                )
              })}
              </ul>
              <p className="font-semibold text-[20px] leading-7 mb-[13px] mt-8">{footerLinks[6].primary.section}</p>
              <ul className="list-none">
                {footerLinks[6].primary.links.map ((item: any, index: number)=>{
                  return (
                    <li className="hover:underline underline-offset-4" key={index}><PrismicNextLink field={item.link} aria-label={footerLinkLabel(item)} className="inline-flex min-h-11 items-center">{item.link_text}</PrismicNextLink></li>
                  )
                })}
              </ul>
            </div>
            <div className="col-span-12 md:col-span-4 lg:col-span-2 mt-8 md:mt-0">
              <p className="font-semibold text-[20px] leading-7 mb-[13px]">{footerLinks[3].primary.section}</p>
              <ul className="list-none">
              {footerLinks[3].primary.links.map ((item: any, index: number)=>{
                return (
                  <li className="hover:underline underline-offset-4" key={index}><PrismicNextLink field={item.link} aria-label={footerLinkLabel(item)} className="inline-flex min-h-11 items-center">{item.link_text}</PrismicNextLink></li>
                )
              })}
              </ul>
              <p className="font-semibold text-[20px] leading-7 mb-[13px] mt-8">{footerLinks[7].primary.section}</p>
              <ul className="list-none">
                {footerLinks[7].primary.links.map ((item: any, index: number)=>{
                  return (
                    <li className="hover:underline underline-offset-4" key={index}><PrismicNextLink field={item.link} aria-label={footerLinkLabel(item)} className="inline-flex min-h-11 items-center">{item.link_text}</PrismicNextLink></li>
                  )
                })}
                </ul>
            </div>
          <div className="col-span-12 lg:col-span-1"></div>
          <div className="col-span-12 md:col-span-3 mt-16 lg:mt-0">
            <p className="font-semibold text-[20px] leading-7 mb-[13px]">{socialLinks.primary.social_title}</p>
            <ul className="list-none">
              {socialLinks.primary.links.map ((item: any, index: number)=>{
                const platformName = (() => {
                  try {
                    const host = new URL(item.link.url).hostname.replace('www.', '');
                    const name = host.split('.')[0];
                    return name.charAt(0).toUpperCase() + name.slice(1);
                  } catch { return 'Social media'; }
                })();
                return (
                  <li className="inline-block mr-3" key={index}><PrismicNextLink field={item.link} aria-label={`Tuatahi First Fibre on ${platformName}`} className="inline-flex min-w-11 min-h-11 items-center justify-center"><PrismicNextImage field={item.icon} fallbackAlt="" className="w-10 h-10 object-contain" /></PrismicNextLink></li>
                )
              })}
              </ul>
              <p className="font-semibold text-[20px] mt-8"><a href={`tel: ${core.data.phone_number}`}>{core.data.phone_number_display}</a></p>
          </div>
        </div>
        </div>
      </div>
        <div className="border-t border-t-white w-full py-8 text-[14px] mt-16 px-4 md:px-8 lg:px-12">
          <div className="grid grid-cols-12 max-w-7xl mx-auto">
              <div className="col-span-12 md:col-span-6">
                <p>{core.data.copyright_text.replace("[YYYY]", currentYear)}</p>
              </div>
              <div className="col-span-12 md:col-span-6 flex justify-end">
                {/* <img src={core.inverse_footer_logo.url} alt={core.copyright_text}/> */}
              </div>
          </div>
        </div>
        
    </div>
  )
}
export default FooterNav;
